module.exports = __webpack_public_path__ + "img/0xa1303e6199b319a891b79685f0537d289af1fc83.9b4bfd19.png";